'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SavingDataIndicator = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(SavingDataIndicator, _Component);

  function SavingDataIndicator() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SavingDataIndicator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SavingDataIndicator.__proto__ || (0, _getPrototypeOf2.default)(SavingDataIndicator)).call.apply(_ref, [this].concat(args))), _this), _this.getVisibility = function () {
      var _this2;

      return (_this2 = _this).__getVisibility__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SavingDataIndicator, [{
    key: 'render',
    value: function render() {
      var devMode = this.props.devMode;

      return _react2.default.createElement(
        'div',
        { className: 'saving-data-container' },
        _react2.default.createElement(
          'div',
          { className: this.getVisibility(this.props.appState) },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'saving-spinner' },
              _react2.default.createElement('div', { className: 'spinner' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'saving-message' },
              'Please Wait...'
            )
          )
        ),
        devMode !== false && _react2.default.createElement(InjectDevControls, { appState: this.props.appState })
      );
    }
  }, {
    key: '__getVisibility__REACT_HOT_LOADER__',
    value: function __getVisibility__REACT_HOT_LOADER__() {
      return this.__getVisibility__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getVisibility__REACT_HOT_LOADER__',
    value: function __getVisibility__REACT_HOT_LOADER__() {
      return this.__getVisibility__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getVisibility__REACT_HOT_LOADER__',
    value: function __getVisibility__REACT_HOT_LOADER__(props) {
      var visibilityClass = void 0;
      if (props.saveInProgress === true) {
        visibilityClass = 'saving-data-indicator';
      } else {
        visibilityClass = 'saving-data-indicator hidden';
      }
      return visibilityClass;
    }
  }]);
  return SavingDataIndicator;
}(_react.Component)) || _class;

;

var InjectDevControls = (0, _mobxReact.observer)(function (props) {
  return props.appState.saveInProgress ? _react2.default.createElement(
    'div',
    { className: 'saving-data-dev-controls' },
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          return props.appState.saveInProgress = false;
        } },
      'Simulate Save Complete'
    )
  ) : _react2.default.createElement(
    'div',
    { className: 'saving-data-dev-controls' },
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          return props.appState.saveInProgress = true;
        } },
      'Simulate Save In Progress'
    )
  );
});

var _default = SavingDataIndicator;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SavingDataIndicator, 'SavingDataIndicator', 'src/core_modules/ui-blocking-modal/index.js');

  __REACT_HOT_LOADER__.register(InjectDevControls, 'InjectDevControls', 'src/core_modules/ui-blocking-modal/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/ui-blocking-modal/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/ui-blocking-modal/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/ui-blocking-modal/index.js
// module chunks = 0